import { INFRACTION_LIST_SEARCH_MAX_LENGTH } from "../constants/infraction-table-columns.constant";

const INFRACTION_LIST_SEARCH_ALLOWED_CHARS_REGEX = /[^0-9A-Za-zÀ-ÖØ-öø-ÿ\s.-]/g;

/**
 * Sanitiza a busca da listagem: placa, nome/CPF do condutor ou número do auto.
 * Remove caracteres especiais e aplica o limite de tamanho.
 */
export function sanitizeInfractionListSearch(value: string): string {
	return value
		.replace(INFRACTION_LIST_SEARCH_ALLOWED_CHARS_REGEX, "")
		.slice(0, INFRACTION_LIST_SEARCH_MAX_LENGTH);
}
